import {NotificationComponent} from './notification.component';
import {Injectable, Injector} from '@angular/core';
import {TYPES} from './notification.types';
import {endsWith, isNumber, remove, isNil} from 'lodash';
import {NavigationStart, Router} from '@angular/router';


const DEFAULT_DELAY = 10000;//ms
const ROOT_CONTAINER = document.querySelector('.notifies');

//Service for rendering notification messages at page right panel

@Injectable()
export class NotificationManager {

    private RELOAD_PAGE_STRING: string = 'Reload page.';
    private destroyComponentFunctions: Array<Function> = [];
    private parentEl: Element;

    constructor(private _injector: Injector) {
        this.onLeaveRouteClearAllNotification();
        this.parentEl = ROOT_CONTAINER;
    }

    public changeParentEl(el: Element): NotificationManager {
        this.parentEl = (el) ? el : ROOT_CONTAINER;
        return this;
    }

    public clearAllNotification(): void {
        remove(this.destroyComponentFunctions, destroyFunction => {
            destroyFunction();
            return true;
        });
    }

    /**
     * Render error notification
     * @param template                  - html template for notification content
     * @param delay                     - autoclose delay (boolean,number)
     * @returns {Function}              - function to close notification
     */
    public error(template: string, delay?: number | boolean) {
        return this.placeNotifyElement(TYPES.DANGER, template, delay);
    }

    /**
     * Render warning notification
     * @param template                  - html template for notification content
     * @param delay                     - autoclose delay (boolean,number)
     * @returns {Function}              - function to close notification
     */
    public warning(template: string, delay?: number | boolean) {
        return this.placeNotifyElement(TYPES.WARNING, template, delay);
    }

    /**
     * Render success notification
     * @param template                  - html template for notification content
     * @param delay                     - autoclose delay (boolean,number)
     * @returns {Function}              - function to close notification
     */
    public success(template: string, delay?: number | boolean) {
        return this.placeNotifyElement(TYPES.SUCCESS, template, delay);
    }

    public primary(template: string, delay?: number | boolean) {
        return this.placeNotifyElement(TYPES.PRIMARY, template, delay);
    }

    private onLeaveRouteClearAllNotification() {
        setTimeout(() => { // TODO: Resolve cyclic DI
            this._injector.get(Router).events.subscribe(event => {
                if (event instanceof NavigationStart) {
                    this.destroyComponentFunctions.forEach((f) => f());
                    this.destroyComponentFunctions = [];
                }
            });
        });
    }

    private createNotifyContent(template: string) {
        if (endsWith(template, this.RELOAD_PAGE_STRING)) {
            let message = template.substr(0, template.length - this.RELOAD_PAGE_STRING.length);
            return `${message} <a id="link_in_error" href="javascript:window.location.reload(true)">${this.RELOAD_PAGE_STRING}</a>`;
        }

        return template;
    }

    private destroyNotifyElement(element: NotificationComponent) {
        if (element) {
            element.destroy();
        }
    }

    private createNotifyElement(type: string, content: string) {
        return new NotificationComponent(type, content);
    }

    private placeNotifyElement(type, template: string, delay?: number | boolean): Function {
        if (isNil(delay)) {
            delay = true;
        }
        // restore parent element if it was dynamically removed
        if (!document.body.contains(this.parentEl)) {
            this.parentEl = ROOT_CONTAINER;
        }

        let content = this.createNotifyContent(template);
        let element = this.createNotifyElement(type, content);
        this.parentEl.appendChild(element.getElement());
        //
        if (delay === true) {
            delay = DEFAULT_DELAY;
        }
        //
        if (isNumber(delay)) {
            setTimeout(() => {
                this.destroyNotifyElement(element);
            }, delay);
        }
        let destroyFunc = () => {
            this.destroyNotifyElement(element);
        };
        this.destroyComponentFunctions.push(destroyFunc);
        return destroyFunc;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/notification/notification.manager.ts